// Header.js
import React from 'react';
import './Header.css'; // Import your custom styles
import logo from '../../images/splash/splash.png'; // Go up two directories to reach src
import profile from '../../images/splash/supplier1.jpg'; // Go up two directories to reach src
import { useState,useEffect,useRef } from 'react';
import { Link, useHistory } from "react-router-dom";

const Header = ({ onToggleSidebar }) => {
  const getInitials = (name) => {
    const nameArray = name.split(" ");
    const initials = nameArray.map((word) => word.charAt(0).toUpperCase()).join("");
    return initials;
  };
  const emailText = "John Doe";
  const messageCount = 3;
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const dropdownRef = useRef(null);
  const history = useHistory(); 

  const toggleDropdown = () => {
    setDropdownVisible(!dropdownVisible);
  };
  // Get initials for the avatar
  const initials = getInitials(emailText);
  const dropdownStyles = {
    position: 'absolute',
    top: '100%',
    right: 0,
    backgroundColor: '#fff',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    borderRadius: '8px',
    padding: ' 5px 10px',
    width:"100px",
    zIndex: 1,
    textAlign: 'center'
  };
  // Generate the default avatar URL
  const defaultProfilePic = `https://ui-avatars.com/api/?name=${initials}&color=black`;
// Helper function to get initials from name
const handleClickOutside = (event) => {
  if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
    setDropdownVisible(false);
  }
};


const handleLogout = () => {
  // Perform logout actions, such as clearing tokens or session data
  localStorage.removeItem('SAtoken'); // Example: remove token from localStorage
  history.push('/admin'); // Redirect to the /admin page
};

useEffect(() => {
  if (dropdownVisible) {
    document.addEventListener("mousedown", handleClickOutside);
  } else {
    document.removeEventListener("mousedown", handleClickOutside);
  }

  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
  };
}, [dropdownVisible]);
  return (
    <header className="app-header">
    <div className="header-content">
      <div style={{ display: 'flex', alignItems: 'center' }}>
      
        <h1 style={{ marginRight: "20px" }}>SUPER ADMIN</h1>
      </div>
      <div className="profile-info">
        <div className="profile-pic-wrapper" style={{ position: 'relative' }} ref={dropdownRef}>
          <img 
            src={defaultProfilePic} 
            alt="Profile" 
            className="profile-pic" 
            onClick={toggleDropdown}
          />
         {dropdownVisible && (
  <div className="profile-dropdown" style={dropdownStyles}>
    {/* Optional profile image */}
  
    <div className="profile-info-text">
      <p className="profile-name">{emailText}</p>
    </div>

    {/* Divider line */}
    <div className="dropdown-divider"></div>

    {/* Logout button */}
    <button  className="logout-button" onClick={handleLogout}>
      <i className="bi bi-power" style={{ marginRight: "5px" }}></i>Logout
    </button>
  </div>
)}

        </div>
        <div className="notification-icon">
          <i className="bi bi-bell"></i>
          {messageCount > 0 && (
            <span className="notification-badge">{messageCount}</span>
          )}
        </div>
      </div>
    </div>
  </header>

  
  );
};

export default Header;
